import { memo, useContext, useCallback } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const Showroom = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	const categorySelect = useCallback((e) => {
		setInputs(() => ({
			...inputs,
			showroom: e.target.value,
		}));
		setErrors(() => ({ ...errors, subject: null }));
	});

	const catList = ["本社名古屋ショールーム", "東京銀座ショールーム", "東京青山ショールーム", "横浜関内ショールーム", "大阪四ツ橋ショールーム"];

	return (
		<div className={styles.category}>
			<h3 className={`en ${styles.headline}`}>
				SHOWROOM<span>ご希望のショールームをお選びください</span>
			</h3>
			<div>
				{catList.map((item, index) => {
					return (
						<label
							key={index}
							onChange={categorySelect}
							style={
								item === inputs.showroom
									? { backgroundColor: "#1c1c1c", color: "#fff" }
									: null
							}
						>
							<input name="showroom" type="radio" value={item} />
							{item}
						</label>
					);
				})}
			</div>
		</div>
	);
});

export default Showroom;
